import {USERS_FETCH_REQUESTED} from "../../constants/ActionTypes";

export const fetchUsers = () => ({type: USERS_FETCH_REQUESTED});
